import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDialog,{attrs:{"scrollable":"","persistent":"","overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(VCard,[_c(VCardText,{staticClass:"mt-5"},[_c('div',{attrs:{"id":"show_description"}})]),_c(VDivider),_c(VCardActions,{staticClass:"justify-end"},[_c(VBtn,{attrs:{"color":"error","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Fechar\n        ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }